import React from 'react';

export const tagsCellRender = props => {
    let tags = props.value;

    //sst: handle string tags
    if ('string' === typeof tags) {
        tags = tags.split(',');
    }

    return tags?.length ? (
        <span className="ag-tags tags">
            {tags.map((tag, i) => (
                <span key={i} className="ag-tag badge rounded-pill bg-primary">
                    {tag}
                </span>
            ))}
        </span>
    ) : (
        ''
    );
};
